var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c(_vm.template, {
    tag: "component"
  }, [_c('div', {
    staticClass: "contents-area"
  }, [_c('div', {
    staticClass: "tit-wrap tit-wrap--unberline"
  }, [_c('h2', {
    staticClass: "tit"
  }, [_vm._v("선물하기")])]), _c('div', {
    staticClass: "contents-area__inner"
  }, [_c('section', {
    staticClass: "page-section pt-0"
  }, [_c('v-divider', {
    staticClass: "grey darken-4"
  }), _vm._l(_vm.carts, function (cart, index) {
    return [index ? _c('v-divider') : _vm._e(), _c('pickup-item', {
      key: cart._id,
      attrs: {
        "cart": cart
      }
    })];
  }), _c('v-divider'), _c('div', {
    staticClass: "card--primary"
  }, [_c('v-row', {
    staticClass: "row--x-small font-size-14 font-size-md-16",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('span', [_vm._v("총 상품가격("), _c('b', [_vm._v(_vm._s(_vm.saleAmount.format()) + "원")]), _vm._v(")")])]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("+")]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('span', [_vm._v("총 배송비("), _c('b', [_vm._v(_vm._s(_vm.shippingAmount.format()) + "원")]), _vm._v(")")])]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("=")]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('div', {
    staticClass: "d-flex align-center"
  }, [_c('span', [_vm._v("총 결제 예상 금액")]), _c('b', {
    staticClass: "font-size-20 font-size-md-24 ml-10px ml-md-12px"
  }, [_vm._v(_vm._s(_vm.totalAmount.format()) + "원")])])])], 1)], 1)], 2), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: false,
      expression: "false"
    }],
    staticClass: "page-section"
  }, [_c('div', {
    staticClass: "mb-10px mb-md-20px"
  }, [_c('h3', {
    staticClass: "tit tit--xs"
  }, [_vm._v("구매자 정보 입력")]), _c('v-divider', {
    staticClass: "grey lighten-1 mt-10px"
  })], 1), _c('div', {
    staticClass: "w-100 mw-500px"
  }, [_c('v-row', {
    staticClass: "row--x-small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "이름",
      "outlined": "",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.giftOrder.buyer.name,
      callback: function callback($$v) {
        _vm.$set(_vm.giftOrder.buyer, "name", $$v);
      },
      expression: "giftOrder.buyer.name"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', {
    staticClass: "row--x-small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', [_c('v-select', _vm._b({
    attrs: {
      "items": _vm.phones,
      "placeholder": "연락처",
      "outlined": "",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.giftOrder.buyer.phone1,
      callback: function callback($$v) {
        _vm.$set(_vm.giftOrder.buyer, "phone1", $$v);
      },
      expression: "giftOrder.buyer.phone1"
    }
  }, 'v-select', _vm.$attrs, false))], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("-")]), _c('v-col', [_c('v-text-field', _vm._b({
    attrs: {
      "outlined": "",
      "hide-details": "",
      "maxlength": "4"
    },
    model: {
      value: _vm.giftOrder.buyer.phone2,
      callback: function callback($$v) {
        _vm.$set(_vm.giftOrder.buyer, "phone2", $$v);
      },
      expression: "giftOrder.buyer.phone2"
    }
  }, 'v-text-field', _vm.$attrs, false))], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("-")]), _c('v-col', [_c('v-text-field', _vm._b({
    attrs: {
      "outlined": "",
      "hide-details": "",
      "maxlength": "4"
    },
    model: {
      value: _vm.giftOrder.buyer.phone3,
      callback: function callback($$v) {
        _vm.$set(_vm.giftOrder.buyer, "phone3", $$v);
      },
      expression: "giftOrder.buyer.phone3"
    }
  }, 'v-text-field', _vm.$attrs, false))], 1)], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "이메일",
      "outlined": "",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.giftOrder.buyer.email,
      callback: function callback($$v) {
        _vm.$set(_vm.giftOrder.buyer, "email", $$v);
      },
      expression: "giftOrder.buyer.email"
    }
  })], 1)], 1)], 1)]), _c('section', {
    staticClass: "page-section"
  }, [_c('div', {
    staticClass: "mb-10px mb-md-20px"
  }, [_c('h3', {
    staticClass: "tit tit--xs"
  }, [_vm._v("선물 받으시는분")]), _c('v-divider', {
    staticClass: "grey lighten-1 mt-10px"
  })], 1), _c('div', {
    staticClass: "w-100 mw-500px"
  }, [_c('v-row', {
    staticClass: "row--x-small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', [_c('v-select', _vm._b({
    attrs: {
      "items": _vm.phones,
      "placeholder": "연락처",
      "outlined": "",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.giftOrder.receiver.phone1,
      callback: function callback($$v) {
        _vm.$set(_vm.giftOrder.receiver, "phone1", $$v);
      },
      expression: "giftOrder.receiver.phone1"
    }
  }, 'v-select', _vm.$attrs, false))], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("-")]), _c('v-col', [_c('v-text-field', _vm._b({
    attrs: {
      "outlined": "",
      "hide-details": "",
      "maxlength": "4"
    },
    model: {
      value: _vm.giftOrder.receiver.phone2,
      callback: function callback($$v) {
        _vm.$set(_vm.giftOrder.receiver, "phone2", $$v);
      },
      expression: "giftOrder.receiver.phone2"
    }
  }, 'v-text-field', _vm.$attrs, false))], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("-")]), _c('v-col', [_c('v-text-field', _vm._b({
    attrs: {
      "outlined": "",
      "hide-details": "",
      "maxlength": "4"
    },
    model: {
      value: _vm.giftOrder.receiver.phone3,
      callback: function callback($$v) {
        _vm.$set(_vm.giftOrder.receiver, "phone3", $$v);
      },
      expression: "giftOrder.receiver.phone3"
    }
  }, 'v-text-field', _vm.$attrs, false))], 1)], 1)], 1)]), _c('section', {
    staticClass: "page-section"
  }, [_c('div', {
    staticClass: "mb-10px mb-md-20px"
  }, [_c('h3', {
    staticClass: "tit tit--xs"
  }, [_vm._v("전달 메세지")]), _c('v-divider', {
    staticClass: "grey lighten-1 mt-10px"
  })], 1), _c('div', [_c('v-row', {
    staticClass: "row--x-small",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', [_c('v-textarea', {
    attrs: {
      "placeholder": "문자 전달 메세지",
      "outlined": "",
      "persistent-placeholder": "",
      "rows": "3",
      "hide-details": ""
    },
    model: {
      value: _vm.giftOrder.message,
      callback: function callback($$v) {
        _vm.$set(_vm.giftOrder, "message", $$v);
      },
      expression: "giftOrder.message"
    }
  })], 1)], 1)], 1)]), _c('section', {
    staticClass: "page-section"
  }, [_c('div', {
    staticClass: "mb-10px mb-md-20px"
  }, [_c('h3', {
    staticClass: "tit tit--xs"
  }, [_vm._v("선물약관")]), _c('v-divider', {
    staticClass: "grey lighten-1 mt-10px"
  })], 1), _c('div', [_c('div', {
    staticClass: "page-text"
  }, [_c('p', [_vm._v("※ 상품 선물 시 상대방의 휴대번호로 SMS URL이 발송되어 거절 또는 수락 후 배송지를 입력할 수 있습니다.")]), _c('p', [_vm._v("※ 수신자가 SMS URL 수신 후 선물 수락 또는 상품 구매 출고 배송 시 취소가 불가능하므로 주의 해 주세요.")]), _c('p', [_vm._v("※ 선물하기로 상품을 발송하시는 경우 일반상품으로 분류되어 소득공제가 불가 합니다.")])])]), _c('v-divider', {
    staticClass: "mt-10px mt-md-20px"
  })], 1), _c('section', {
    staticClass: "page-section pt-0 text-center"
  }, [_c('v-checkbox', {
    staticClass: "d-inline-flex ma-0",
    attrs: {
      "label": "동의합니다",
      "hide-details": ""
    },
    model: {
      value: _vm.aggreement,
      callback: function callback($$v) {
        _vm.aggreement = $$v;
      },
      expression: "aggreement"
    }
  })], 1), _c('section', {
    staticClass: "page-section pb-0"
  }, [_c('v-row', {
    staticClass: "row--x-small",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "x-large": "",
      "color": "primary"
    },
    on: {
      "click": _vm.pay
    }
  }, [_vm._v("선물하기")])], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "x-large": "",
      "outlined": "",
      "color": "grey"
    },
    on: {
      "click": function click($event) {
        return _vm.$router.go(-1);
      }
    }
  }, [_c('span', {
    staticClass: "grey--text text--darken-3"
  }, [_vm._v("취소하기")])])], 1)], 1)], 1)])]), _c('daum-postcode', {
    ref: "daumPostcode",
    on: {
      "input": function input(_ref) {
        var postcode = _ref.postcode,
            address = _ref.address;
        _vm.giftOrder.shippingAddress.postcode = postcode;
        _vm.giftOrder.shippingAddress.address1 = address;
      }
    }
  }), _c('nice-pay', {
    ref: "nicePay"
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }